import { stripTags } from '@utils/jsonLd/text';

export interface CatalogFaqItem {
  title: string;
  answer: string;
}

export const selectCatalogFaqItems = (
  items:
    | ReadonlyArray<{
        title?: string | null;
        answer?: string | null;
      } | null>
    | null
    | undefined
): CatalogFaqItem[] =>
  (items ?? []).filter(
    (item): item is CatalogFaqItem =>
      !!item?.title?.trim() && !!stripTags(item?.answer)
  );
